/* eslint-disable @typescript-eslint/no-explicit-any , react/no-array-index-key, max-len */
import React from 'react'

import config from 'config'

import Chart from '../Chart'
import { DashboardItemProps } from '../types'
import {
    BoardAutoContainer,
    BoardAppStatistics,
    BoardAppStats,
    BoardAutoChart,
    BoardAppStat,
    BoardFundedStatistics,
    BoardFundedStats,
    BoardFundedStat,
    BoardIFrame,
} from './AutoBoard.styled'

// This url could be part of the DashboardItem, but for now, it will be placed here
const marketingIFrameUrl = config.AUTO_BOARD_MARKETING_CONTENT

function AutoBoard({ componentStyle, data }: DashboardItemProps) {
    return (
        <BoardAutoContainer componentStyle={componentStyle}>
            <BoardFundedStatistics>
                <BoardFundedStats>
                    {data.statistics.fundedItems.map(
                        (stat: any, index: number) => {
                            return (
                                <BoardFundedStat key={index}>
                                    <strong>{stat.value}</strong>
                                    <span>{stat.label}</span>
                                </BoardFundedStat>
                            )
                        },
                    )}
                </BoardFundedStats>
            </BoardFundedStatistics>
            <BoardAppStatistics>
                <BoardAppStats>
                    {data.statistics.items.map((stat: any, index: number) => {
                        return (
                            <BoardAppStat key={index}>
                                <strong>{stat.value}</strong>
                                <span>{stat.label}</span>
                            </BoardAppStat>
                        )
                    })}
                </BoardAppStats>
            </BoardAppStatistics>
            <BoardIFrame>
                <iframe
                    src={marketingIFrameUrl}
                    scrolling="false"
                    title="marketing_frame"
                />
            </BoardIFrame>
            <BoardAutoChart>
                <h5>
                    {data.chart.title}
                    <small>
                        <strong>{data.chart.totalFunded}</strong>{' '}
                        {data.chart.label}
                    </small>
                </h5>
                <Chart data={data.chart.data} />
            </BoardAutoChart>
            <footer>
                <h5>{data.footer.title}</h5>
                {data.footer.stats.map((stat: any, index: number) => {
                    return (
                        <div className="stat" key={index}>
                            <b>{stat.title}</b>
                            <strong>{stat.value}</strong>
                            <span>{stat.description}</span>
                        </div>
                    )
                })}
            </footer>
        </BoardAutoContainer>
    )
}

export default AutoBoard
